/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ToastContainer } from "react-toastify";
import React from "react";

const SimpliCityToast = () => {
    
    return (
        <ToastContainer />
    );
};

export { SimpliCityToast };
